export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const GET_ALL_CUSTOMERS_REQUEST = "GET_ALL_CUSTOMERS_REQUEST";
export const GET_ALL_CUSTOMERS_SUCCESS = "GET_ALL_CUSTOMERS_SUCCESS";
export const GET_ALL_CUSTOMERS_FAIL = "GET_ALL_CUSTOMERS_FAIL";

export const GET_ALL_EMPLOYEES_REQUEST = "GET_ALL_EMPLOYEES_REQUEST";
export const GET_ALL_EMPLOYEES_SUCCESS = "GET_ALL_EMPLOYEES_SUCCESS";
export const GET_ALL_EMPLOYEES_FAIL = "GET_ALL_EMPLOYEES_FAIL";

export const GET_ALL_ROLES_REQUEST = "GET_ALL_ROLES_REQUEST";
export const GET_ALL_ROLES_SUCCESS = "GET_ALL_ROLES_SUCCESS";
export const GET_ALL_ROLES_FAIL = "GET_ALL_ROLES_FAIL";

export const GET_ALL_INQUIRIES_REQUEST = "GET_ALL_INQUIRIES_REQUEST";
export const GET_ALL_INQUIRIES_SUCCESS = "GET_ALL_INQUIRIES_SUCCESS";
export const GET_ALL_INQUIRIES_FAIL = "GET_ALL_INQUIRIES_FAIL";

export const GET_ALL_INQUIRY_TYPES_REQUEST = "GET_ALL_INQUIRY_TYPES_REQUEST";
export const GET_ALL_INQUIRY_TYPES_SUCCESS = "GET_ALL_INQUIRY_TYPES_SUCCESS";
export const GET_ALL_INQUIRY_TYPES_FAIL = "GET_ALL_INQUIRY_TYPES_FAIL";

export const GET_ALL_FINS_REQUEST = "GET_ALL_FINS_REQUEST";
export const GET_ALL_FINS_SUCCESS = "GET_ALL_FINS_SUCCESS";
export const GET_ALL_FINS_FAIL = "GET_ALL_FINS_FAIL";
